import React, { useContext, useState } from "react";
import TimeTableContext from "../../../context/timeTableContext";

function CirclePlus(props) {
  const context = useContext(TimeTableContext);
  return (
    <div
      className="circle-status"
      onClick={() => {
        context.dispatch({
          type: "SET_OPEN_DECK",
          payload: !context.state.openDeck,
        });
      }}
    >
      {context.state.openDeck ? "-" : "+"}
    </div>
  );
}

export default CirclePlus;
